import { Component, HostBinding } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  standalone: false,
  selector: 'learning-curve-group-renderer',
  templateUrl: './learning-curve-group-renderer.component.html',
  styleUrls: ['./learning-curve-group-renderer.component.css']
})
export class LearningCurveGroupRendererComponent implements ICellRendererAngularComp {
  // WCAG 4.1.2 Name, Role, Value (WAI-ARIA Grid pattern): when this component is
  // AG Grid's full-width cell renderer for a learning-curve group row, its host
  // is the only child of the role="row" element, so that row would otherwise
  // have no gridcell/rowheader/columnheader child and the "Add Class" button
  // ends up as an invalid owned element of the treegrid (arc: "ARIA widget has
  // incorrect owned element inside tree role"). Expose the host as a gridcell in
  // that case so the row structure is valid. When the component is used as a
  // group-row inner renderer it already sits inside a gridcell, so we must NOT
  // add a nested gridcell there — hence the full-width ('curve') guard.
  @HostBinding('attr.role')
  get hostRole(): string | null {
    return this.params?.data?.type === 'curve' ? 'gridcell' : null;
  }

  onAdd(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.params.context.onAddClass(this.params.data);

  }

  get isGroupCollapsed(): boolean {
    // Always get the current state from the ag-grid node
    return this.params?.node ? !this.params.node.expanded : false;
  }

  get hasChildren(): boolean {
    // Check if the ag-grid node has children
    return this.params?.node?.childrenAfterGroup && this.params.node.childrenAfterGroup.length > 0;
  }

  toggleGroup() {
    if (this.params && this.params.node) {
      // Toggle the expanded state of the group
      const isExpanded = this.params.node.expanded;
      this.params.node.setExpanded(!isExpanded);
    }
  }

  public params: ICellRendererParams;
  public isCurve: boolean = false;
  public isClass: boolean = false;
  public displayValue: string = '';

  agInit(params: ICellRendererParams): void {
    this.params = params;
    // console.log(params.data);
    if (params.data?.type === 'curve') {
      this.isCurve = true;
      this.displayValue = params.data.name;
    } else if (params.data?.type === 'class') {
      this.isClass = true;
      this.displayValue = params.data.managementUnit;
    } else {
      this.displayValue = params.value;
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }

  onGroupNameClick(event: Event) {
    if (this.isCurve) {
      event.preventDefault();
      event.stopPropagation();
      // Emit event to parent component to open edit dialog
      if (this.params.context && this.params.context.onEditLearningCurve) {
        this.params.context.onEditLearningCurve(this.params.data);
      }
    }
  }
}
